<h2 mat-dialog-title>{{ 'team_members_batch_update.'+ data.property | translate }}</h2>

<mat-dialog-content class="dialog-content-pad-15">
  <p class="pb-2">{{ descriptionKey | translate : { count: data.selectedTeamMembers.length } }}</p>
  
  <ng-container #componentPlaceholder></ng-container>

  @if (data.property === 'role') {
    <team-member-roles [userRoles]="value"
                       [teamId]="data.teamId"
                       (onRoleChanges)="updateRole($event)"></team-member-roles>
  }
  
</mat-dialog-content>

<mat-dialog-actions>

  <button type="button" class="btn btn-default" mat-dialog-close>
    {{'cancel' | translate}}
  </button>

  <button class="btn btn-primary" type="button" (click)="update()">
    <i class="fa fa-check"></i>&nbsp;{{'update' | translate}}
  </button>

</mat-dialog-actions>
